import { render, staticRenderFns } from "./AbsentLetterConfig.vue?vue&type=template&id=2af78d36&scoped=true"
import script from "./AbsentLetterConfig.vue?vue&type=script&lang=js"
export * from "./AbsentLetterConfig.vue?vue&type=script&lang=js"
import style0 from "./AbsentLetterConfig.vue?vue&type=style&index=0&id=2af78d36&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af78d36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af78d36')) {
      api.createRecord('2af78d36', component.options)
    } else {
      api.reload('2af78d36', component.options)
    }
    module.hot.accept("./AbsentLetterConfig.vue?vue&type=template&id=2af78d36&scoped=true", function () {
      api.rerender('2af78d36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/absent_letter_v3/components/dialog/AbsentLetterConfig.vue"
export default component.exports